export const GET_SMARTLIST_START = 'GET_SMARTLIST_START';
export const RESET_SMARTLIST = 'RESET_SMARTLIST';
export const GET_SMARTLIST_SUCCESS = 'GET_SMARTLIST_SUCCESS';
export const GET_SMARTLIST_FAIL = 'GET_SMARTLIST_FAIL';
